import { QueryClient } from '@tanstack/react-query';

/**
 * The global React Query client.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

/**
 * Unwraps a query response and returns the first result(s).
 * Returns an empty array if the query result is undefined.
 *
 * @param response The query response.
 */
export async function resultsOf<T>(response: Promise<{ Result: T[] }>): Promise<T[]> {
    return (await response).Result;
}

/**
 * Unwraps a query response and returns the first result.
 * Returns undefined if the response contains an empty array.
 * Returns undefined if the query result is undefined.
 *
 * @param response The query response.
 */
export async function firstResultOf<T>(
    response: Promise<{ Result: T[] }>
): Promise<T | undefined> {
    const res = await resultsOf(response);
    return res[0];
}
